<template>
  <footer class="site-footer">
    <!-- Main Footer -->
    <div class="footer-main">
      <div class="footer-container">
        <!-- Brand Section -->
        <div class="brand-section">
          <div class="brand-logo">
            <img src="/images/logo.png" alt="Fluxreload">
            <span class="brand-name">Fluxreload</span>
          </div>
          <p class="brand-description">
            La plus grande boutique en ligne de cartes de paiement, cartes cadeaux et recharges mobiles en Afrique.
          </p>
          <div class="social-links">
            <a href="https://facebook.com/fluxreload" target="_blank" rel="noopener" class="social-link facebook">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
              </svg>
            </a>
            <a href="https://twitter.com/fluxreload" target="_blank" rel="noopener" class="social-link twitter">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </a>
            <a href="https://instagram.com/fluxreload" target="_blank" rel="noopener" class="social-link instagram">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
            </a>
            <a href="https://linkedin.com/company/fluxreload" target="_blank" rel="noopener" class="social-link linkedin">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
              </svg>
            </a>
          </div>
        </div>

        <!-- Quick Links -->
        <div class="links-section">
          <div class="links-column">
            <h4 class="column-title">Produits</h4>
            <ul class="links-list">
              <li><router-link to="/mobile-top-up" class="footer-link">Recharge mobile</router-link></li>
              <li><router-link to="/cards/payment-cards" class="footer-link">Cartes de paiement</router-link></li>
              <li><router-link to="/cards/entertainment-gift-cards" class="footer-link">Divertissement</router-link></li>
              <li><router-link to="/cards/shopping-gift-cards" class="footer-link">Shopping</router-link></li>
              <li><router-link to="/cards/gaming-cards" class="footer-link">Jeux vidéo</router-link></li>
            </ul>
          </div>

          <div class="links-column">
            <h4 class="column-title">Service</h4>
            <ul class="links-list">
              <li><router-link to="/help" class="footer-link">Centre d'aide</router-link></li>
              <li><router-link to="/how-it-works" class="footer-link">Comment ça marche</router-link></li>
            </ul>
          </div>

          <div class="links-column">
            <h4 class="column-title">Légal</h4>
            <ul class="links-list">
              <li><router-link to="/privacy-statement" class="footer-link">Confidentialité</router-link></li>
              <li><router-link to="/cookie-statement" class="footer-link">Cookies</router-link></li>
              <li><router-link to="/terms" class="footer-link">Conditions d'utilisation</router-link></li>
            </ul>
          </div>
        </div>

        <!-- Newsletter Section -->
        <div class="newsletter-section">
          <h4 class="newsletter-title">Restez informé</h4>
          <p class="newsletter-description">Recevez nos meilleures offres et promotions</p>
          <form class="newsletter-form" @submit.prevent="subscribeNewsletter">
            <input
              v-model="emailInput"
              type="email"
              placeholder="Votre adresse email"
              class="newsletter-input"
              required
            >
            <button type="submit" class="newsletter-button">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="9 18 15 12 9 6"/>
              </svg>
            </button>
          </form>
          <p v-if="newsletterMessage" class="newsletter-message">{{ newsletterMessage }}</p>
        </div>
      </div>
    </div>

    <!-- Bottom Bar -->
    <div class="footer-bottom">
      <div class="footer-container">
        <div class="bottom-content">
          <div class="copyright-section">
            <p class="copyright">© 2026 Fluxreload. Tous droits réservés.</p>
            <p class="made-with-love">
              Fait avec <span class="heart">♥</span> 
            </p>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { ref } from 'vue';

const emailInput = ref('');
const newsletterMessage = ref('');

const subscribeNewsletter = () => {
  if (emailInput.value) {
    newsletterMessage.value = 'Merci pour votre inscription !';
    emailInput.value = '';
    setTimeout(() => {
      newsletterMessage.value = '';
    }, 3000);
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Work+Sans:wght@400;500;600;700;800&display=swap');

/* Footer Container */
.site-footer {
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
  color: white;
  margin-top: auto;
  position: relative;
  overflow: hidden;
}

.site-footer::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #01F37A 0%, #00D9FF 50%, #FF385C 100%);
  background-size: 200% 100%;
  animation: gradientFlow 6s linear infinite;
}

@keyframes gradientFlow {
  0% { background-position: 0% 50%; }
  100% { background-position: 200% 50%; }
}

/* Main Footer */
.footer-main {
  padding: 80px 24px 40px;
}

.footer-container {
  max-width: 1400px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1.5fr 2fr 1fr;
  gap: 60px;
  align-items: start;
}

/* Brand Section */
.brand-section {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.brand-logo {
  display: flex;
  align-items: center;
  gap: 12px;
}

.brand-logo img {
  height: 40px;
  width: auto;
}

.brand-name {
  font-family: 'Work Sans', sans-serif;
  font-size: 28px;
  font-weight: 800;
  background: linear-gradient(135deg, #01F37A 0%, #00D9FF 50%, #FF385C 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.brand-description {
  font-family: 'Work Sans', sans-serif;
  font-size: 15px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.7);
}

/* Social Links */
.social-links {
  display: flex;
  gap: 12px;
}

.social-link {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.6);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.social-link:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.2);
  color: white;
  transform: translateY(-2px);
}

.social-link.facebook:hover {
  background: linear-gradient(135deg, #1877F2, #0d65d9);
  border-color: transparent;
}

.social-link.twitter:hover {
  background: white;
  border-color: transparent;
  color: #000;
}

.social-link.instagram:hover {
  background: linear-gradient(135deg, #833AB4, #FD1D1D, #F77737);
  border-color: transparent;
}

.social-link.linkedin:hover {
  background: linear-gradient(135deg, #0077B5, #005885);
  border-color: transparent;
}

/* Links Section */
.links-section {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
}

.links-column {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.column-title {
  font-family: 'Work Sans', sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: white;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 8px;
}

.links-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.footer-link {
  font-family: 'Work Sans', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.6);
  text-decoration: none;
  transition: all 0.2s ease;
  position: relative;
}

.footer-link:hover {
  color: white;
  padding-left: 4px;
}

.footer-link::before {
  content: '→';
  position: absolute;
  left: -16px;
  opacity: 0;
  color: #01F37A;
  transition: all 0.2s ease;
}

.footer-link:hover::before {
  opacity: 1;
  left: -12px;
}

/* Newsletter Section */
.newsletter-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 32px;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.newsletter-title {
  font-family: 'Work Sans', sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: white;
  margin: 0;
}

.newsletter-description {
  font-family: 'Work Sans', sans-serif;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  margin: 0;
}

.newsletter-form {
  display: flex;
  gap: 8px;
}

.newsletter-input {
  flex: 1;
  padding: 12px 16px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  color: white;
  font-family: 'Work Sans', sans-serif;
  font-size: 14px;
  outline: none;
  transition: all 0.3s ease;
}

.newsletter-input::placeholder {
  color: rgba(255, 255, 255, 0.4);
}

.newsletter-input:focus {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(1, 243, 122, 0.5);
}

.newsletter-button {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: linear-gradient(135deg, #01F37A 0%, #00D9FF 100%);
  border: none;
  color: #1a1a1a;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  flex-shrink: 0;
}

.newsletter-button:hover {
  transform: scale(1.05);
  box-shadow: 0 8px 20px rgba(1, 243, 122, 0.3);
}

.newsletter-message {
  font-family: 'Work Sans', sans-serif;
  font-size: 13px;
  color: #01F37A;
  margin: 0;
}

/* Bottom Bar */
.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  padding: 24px;
}

.bottom-content {
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.copyright-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.copyright {
  font-family: 'Work Sans', sans-serif;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);
  margin: 0;
}

.made-with-love {
  font-family: 'Work Sans', sans-serif;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  margin: 0;
  display: flex;
  align-items: center;
  gap: 4px;
}

.heart {
  color: #FF385C;
  display: inline-block;
  animation: heartbeat 1.5s ease infinite;
}

@keyframes heartbeat {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.2); }
}

.ecouxrf-link {
  color: #01F37A;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.2s ease;
}

.ecouxrf-link:hover {
  color: #00D9FF;
  text-decoration: underline;
}

/* Responsive */
@media (max-width: 1200px) {
  .footer-container {
    grid-template-columns: 1fr 1fr;
    gap: 40px;
  }

  .newsletter-section {
    grid-column: span 2;
  }
}

@media (max-width: 768px) {
  .footer-main {
    padding: 60px 20px 30px;
  }

  .footer-container {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .links-section {
    grid-template-columns: repeat(2, 1fr);
    gap: 32px;
  }

  .newsletter-section {
    grid-column: span 1;
  }

  .bottom-content {
    flex-direction: column;
    gap: 20px;
    text-align: center;
  }

  .copyright-section {
    align-items: center;
  }
}

@media (max-width: 480px) {
  .links-section {
    grid-template-columns: 1fr;
  }

  .brand-logo img {
    height: 32px;
  }

  .brand-name {
    font-size: 22px;
  }
}
</style>
